import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { service_shortcuts_manager } from '@/services/shortcuts/SERVICE__shortcuts_manager';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';

export function WATCHER__is_app_on_focus() {
  const dispatch = use_dispatch();

  /*
   * EFFECTS
   */

  use_effect(() => {
    window.addEventListener('focus', on_visibility_change);
    window.addEventListener('blur', on_visibility_change);
    document.addEventListener('visibilitychange', on_visibility_change);

    return () => {
      window.removeEventListener('focus', on_visibility_change);
      window.removeEventListener('blur', on_visibility_change);
      document.removeEventListener('visibilitychange', on_visibility_change);
    };
  }, []);
  /*
   * EVENTS
   */

  function on_visibility_change() {
    const value = document.visibilityState === 'visible' && document.hasFocus();

    if (!value) service_shortcuts_manager.reset_pressed_keys();

    dispatch(LOCAL__ui_set_boolean({ key: 'global__is_app_on_focus', value }));
  }

  return <></>;
}
